var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dropdown",
    {
      attrs: { trigger: "click" },
      on: { "visible-change": _vm.dropDownIcon, command: _vm.handleCommand },
    },
    [
      _c("span", { staticClass: "el-dropdown-link" }, [
        _vm._v(" " + _vm._s(_vm.timeZone) + " "),
        _c("i", { class: _vm.textIcon }),
      ]),
      _c(
        "el-dropdown-menu",
        {
          staticClass: "lang-dropdown",
          attrs: { slot: "dropdown" },
          slot: "dropdown",
        },
        _vm._l(_vm.timeZoneList, function (zone) {
          return _c(
            "el-dropdown-item",
            { key: zone, attrs: { command: zone } },
            [_vm._v(_vm._s(zone))]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }